import { MicrosoftXboxControllerBatteryFullIcon } from './MicrosoftXboxControllerBatteryFullIcon';

/**
 * author: Austin Andrews
 * id CC73B4E7-6B14-459D-AED5-35E50655C05C
 * name microsoft-xbox-controller-battery-full
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-xbox-controller-battery-full.svg
 * tags
 * - Battery 
 * - Gaming / RPG 
 */
export const MicrosoftXboxGamepadBatteryFullIcon = MicrosoftXboxControllerBatteryFullIcon;
export default MicrosoftXboxGamepadBatteryFullIcon